import React from "react";
import $ from 'jquery' 
import PleaseWaitBox from './PleaseWaitBox'
import DeviceDetailContent from './DeviceDetailContent'
import Header from './Header'
import cookie from 'react-cookie'
import { backend } from '../settings'
import { getItemIndexFromArray } from '../helpers'
import DeviceInfoBar from './DeviceInfoBar'
import DeviceInfoPanel from './DeviceInfoPanel'
import DeviceImagePanel from './DeviceImagePanel'
import ScheduleBox from './ScheduleBox'
import {  Radio } from 'react-bootstrap'

import Fa from 'react-fontawesome'
import TimezonePicker from 'react-bootstrap-timezone-picker'
import Switch from 'react-bootstrap-switch'
import moment from 'moment';

import "react-bootstrap-timezone-picker/dist/react-bootstrap-timezone-picker.min.css"
import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css"

export default class DeviceSettings extends React.Component {
  

  constructor(props) {
    super(props)
    let token = cookie.load('token')
    this.state = {'token' : token, data: false, pendingChanges: [], editTags: false, tags: '', review: false}  
  }


 
  handleError(error) {
    let errormsg = error
    if (!error.length) { errormsg = "Unknown Error Occured. Server response not received."}
    this.props.history.push({pathname: '/404', info: errormsg})
  }

  getData(device, afterSave) {
    let loading = true
    this.setState({data: false, loading: loading})
    console.log('loading')
    $.ajax({
        url: backend + '/my/devices',
        headers: {'Authorization': 'Bearer ' + this.state.token},
        dataType: 'json', cache: false, method: 'GET',
        success: function(result) {
          let index = getItemIndexFromArray(result.data, device)
          let original = result.data[index]

          console.log('setting', result.data.timezone)

          this.setState({
            data: result.data, rotation: original.displays[0].rotation, loading: false, index: index, description: original.description,
            timezone: original.timezone, label: original.label,measure_battery_enabled: original.measure_battery_enabled, 
      measure_network_enabled: original.measure_network_enabled, measure_temperature_enabled: original.measure_temperature_enabled,
      measure_battery_period: original.measure_battery_period, 
measure_network_period: original.measure_network_period, measure_temperature_period: original.measure_temperature_period,
use_schedules: original.use_schedules, heartbeat_default_value: original.heartbeat_default_value, schedules: original.schedules,
tags: original.tags, saving: false, saveCompleted: afterSave, saveFailed: false, pendingChanges: []

          })
        }.bind(this),

        error: function(xhr, status, err) {this.handleError(err)}.bind(this)
    })
  }

  componentWillMount() {
    if (!this.state.token) { window.location.href = backend + '/accounts/login?view=DeviceDetail,' + this.props.match.params.device}
  }
  
  componentDidMount() {

    if (this.props.location.data) {
      let original = this.props.location.data[this.props.location.index]
      this.setState({data: this.props.location.data, index: this.props.location.index,
             description: original.description,rotation: original.displays[0].rotation,
            timezone: original.timezone, label: original.label,measure_battery_enabled: original.measure_battery_enabled, 
      measure_network_enabled: original.measure_network_enabled, measure_temperature_enabled: original.measure_temperature_enabled,
      measure_battery_period: original.measure_battery_period, 
measure_network_period: original.measure_network_period, measure_temperature_period: original.measure_temperature_period,
use_schedules: original.use_schedules, heartbeat_default_value: original.heartbeat_default_value, schedules: original.schedules,
tags: original.tags

          })
    }
    else {
      this.getData(this.props.match.params.device)
    }
  }

  componentWillReceiveProps(nextProps) {
    console.log('will rcv props')
    let index = getItemIndexFromArray(this.state.data, nextProps.match.params.device)
    this.setState({index:index})
  }

  handleTimezoneChange(value) {
    this.setState({timezone: value})
    this.updatePending('timezone', value)
  }

  handleInputChange(event) {
    let item = event.target.name
    let value = event.target.value
    this.setState({[item]: value})
    this.updatePending(item, value)
    }


  handleRotationChange(value) {
    this.setState({'rotation': value})
    this.updatePending('rotation', value)
    }

  handleSwitchToggle(input) {

    let newValue = !this.state[input]
    console.log(newValue)
    this.setState({[input]: newValue})
    this.updatePending(input, newValue)
    }

  handleStateToggle(property) {
    let newValue = !this.state[property]
    this.setState({[property]: newValue})
    }

  handleScheduleAdd() {
        const format = ('HH:mm:ss')
        let now = moment().format(format)
        let date1 = new Date()
        let date2 = new Date()
        date2.setFullYear(date2.getFullYear()+10)
        let newSchedule = {
                        id: Math.floor(100000 + Math.random() * 900000),
                        device: this.state.device,
                        heartbeat_value: 15,
                        period_from: date1,
                        period_to: date2,
                        hour_from: now,
                        hour_to: now,
                        monday: true,
                        tuesday: true,
                        wednesday: true,
                        thursday: true,
                        friday: true,
                        saturday: true,
                        sunday: true,
                    }


        let schedules = this.state.schedules
        schedules.push(newSchedule)
        // this.updatePending('newSchedule', true)
        this.setState({schedules: schedules})
    }

  handleNewSchedule(schedule) {
    let schedules = this.state.schedules
    schedules.pop()
    schedules.push(schedule)
    this.updatePending('newSchedule', true)
    console.log(schedule)
  }

  handleScheduleDelete(index) {
    let schedules = this.state.schedules
    schedules.splice(index,1)
    this.updatePending('newSchedule', true)
    this.setState({schedules: schedules})
  }


  updatePending(item, value) {
    let pending = this.state.pendingChanges

    if (item != 'ScheduleDelete') {
      for(let i = 0; i < pending.length; i++) {
          if(pending[i].item == item) {
              pending.splice(i, 1)
          }
      }
    }

    pending.push({item: item,value: value.toString()})
    this.setState({pendingChanges: pending, saveCompleted: false})
  }


  saveSettings() {
      console.log(this.state.pendingChanges)
      let changes = this.state.pendingChanges
      let chglist = {}
      let scheduleEntries = []
      for(let i = 0; i < changes.length; i++) {
        chglist[changes[i].item] = changes[i].value
        if (changes[i].item.indexOf('Schedule') > -1) {

          scheduleEntries = this.state.schedules
          console.log(scheduleEntries)
        }


      }
      if (scheduleEntries.length) {
          chglist['schedules'] = scheduleEntries
      }

      chglist['device_id'] = this.state.data[this.state.index].device_id

      console.log(JSON.stringify(chglist))

      $.ajax({
        url: backend + '/api/config',
        headers: {'Authorization': 'Bearer ' + this.state.token, 'X-CSRFToken': this.state.csrf},
        dataType : "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(chglist),
        method: 'POST',

        success: function(result) {
            this.getData(this.props.match.params.device, true)
          }.bind(this),

        error: function(xhr, status, err) { this.setState({saving: false, saveFailed: true}) }.bind(this)
      })

  }

  cancel() {
    let original = this.state.data[this.state.index]

    this.setState({
      pendingChanges: [], description: original.description, timezone: original.timezone,
      label: original.label, measure_battery_enabled: original.measure_battery_enabled, 
      measure_network_enabled: original.measure_network_enabled, measure_temperature_enabled: original.measure_temperature_enabled,
      measure_battery_period: original.measure_battery_period, 
measure_network_period: original.measure_network_period, measure_temperature_period: original.measure_temperature_period,
use_schedules: original.use_schedules, heartbeat_default_value: original.heartbeat_default_value, schedules: original.schedules

    })
  }

  editTags() {
      this.setState({editTags: !this.state.editTags })
  }

  render() {

  	let errorDiv = <h3>{this.state.error}</h3>
    let device = this.state.data[this.state.index]
    let avTags = this.state.tags.split(',').map((item,i) => <div className='tagspan' key={i}> <Fa name='tag'/> {item} </div>)
  
          
    return (
      <div>
      <Header data={this.state.data} history={this.props.history}/>
	    { this.state.loading && <PleaseWaitBox/> }	
	    { !this.state.loading && this.state.data && 
        <div>
          <DeviceInfoBar data={device}/>
          <div className="container-fluid x-container-fluid">
            <div className="row">
                <DeviceInfoPanel data={device}/>
                <div className="col-md-8">
                  <h4>Settings<button className="btn btn-info btn-xs pull-right" onClick={this.exit}><Fa name="caret-left" />&nbsp;Back</button></h4>
                  
                  <div className="col-md-12">
                    <div className={this.state.pendingChanges.length ? 'visible' :'hidden'}>
                        <div className="alert alert-warning" role="alert">
                            <p style={{marginBottom: 10}}>
                            <span>You have unsaved pending changes.</span>
                            <button className="btn btn-xs btn-success" style={{marginLeft: 10}} onClick={() => this.saveSettings()}><Fa name="floppy-o"/>&nbsp;Save now</button>
                            <button className="btn btn-xs btn-default" style={{marginLeft: 10}} onClick={() => this.handleStateToggle('review')}><Fa name="list-alt"/>&nbsp;Review</button>
                            <button className="btn btn-xs btn-danger"  style={{marginLeft: 10}} onClick={() => this.cancel()}><Fa name="times"/>&nbsp;Cancel</button>
                            </p>
                            <p>
                            {this.state.review && this.state.pendingChanges.length &&
                              this.state.pendingChanges.map((item, i) => 
                                <li key={i}>Set <b>{item.item}</b> to: <b>{item.value.toString()}</b></li>) 
                            }
                            </p>
                        </div>
                    </div>
                    <div className={this.state.saving ? 'visible' :'hidden'}>
                        <div className="alert alert-success" role="alert">
                            <p style={{marginBottom: 10}}>
                            <span><Fa name='cog' spin />&nbsp;Saving settings. Please wait</span>
                            </p>
                        </div>
                    </div>
                    <div className={this.state.saveCompleted ? 'visible' :'hidden'}>
                        <div className="alert alert-success" role="alert">
                            <p style={{marginBottom: 10}}>
                            <span>Your changes have been saved.</span>
                            </p>
                        </div>
                    </div>
                    <div className={this.state.saveFailed ? 'visible' :'hidden'}>
                        <div className="alert alert-danger" role="alert">
                            <p style={{marginBottom: 10}}>
                            <span>Your changes have not been saved. Please try again.</span>
                            </p>
                        </div>
                    </div>
                  </div>



                  <hr/>
                    <div className="col-md-6" style={{borderRight: '1px solid #ccc'}}>
                      <h5>Timezone</h5>
                      <hr/>

                      <TimezonePicker
                      value  = {this.state.timezone}
                      placeholder   = "Select timezone..."
                      onChange      = {(value) => this.handleTimezoneChange(value)}
                      style = {{width: '100%', marginBottom:15}} />              

                      <h5>Description <i style={{color: '#aaa'}}>max 64 chars</i></h5>
                      <div style={{marginBottom:20}}>
                        <label className="desc-label">
                          <Fa name="pencil"/>
                          <input type="text" 
                          name="description" className="form-control settings-input desc-input"
                          maxLength={64} 
                          value={this.state.description } 
                          onChange={(e) => this.handleInputChange(e)} />
                        </label>
                      </div>
                  
                      <h5>Label <i style={{color: '#aaa'}}>max 16 chars</i></h5>
                      <div style={{marginBottom:20}}>
                        <label className="desc-label">
                          <Fa name="pencil"/>
                          <input type="text" name="label" className="form-control settings-input desc-input" 
                                 value= {this.state.label} onChange={(e) => this.handleInputChange(e)} maxLength={16} />
                        </label>
                      </div>

                    <h5>Tags <i style={{color: '#aaa'}}>{this.state.editTags ? 'comma separated' : ''}</i></h5>
                    <div style={{marginBottom:70}} className={this.state.editTags ? 'hidden' : 'visible'} >
                        {avTags}
                        <span className='tagspan addtag' onClick={() => this.editTags()}> <Fa name='tag'/> <Fa name='plus'/> </span>
                    </div>
                    <div style={{marginBottom:20}} className={this.state.editTags ? 'visible' : 'hidden'}>
                        <div className="input-group">

                        <input ref="taginput" type="text" name="tags" className="form-control" value= {this.state.tags} onChange={(e) => this.handleInputChange(e)} />
                        <span className="input-group-addon" onClick={() => this.editTags()}><Fa name='check'/></span>

                        </div>
                    </div>

                  </div>


                  <div className="col-md-6">

                    <div style={{minHeight: 110}}>
                      <h5 style={{marginTop: 20}}>Display rotation</h5>
                      <hr/>
                      <div className={device.displays.length == 1 ? 'visible row' : 'hidden'} style={{padding: '10px 0'}}>
                        <div className="col-md-6">
                          <Radio name="ori" value="0" defaultChecked={this.state.rotation == 0 ? true: false} 
                          onClick={() => this.handleRotationChange(0)}><b>0&deg;</b> Portrait</Radio>
                          <Radio name="ori" value="90" defaultChecked={this.state.rotation == 90 ? true: false} 
                          onClick={() => this.handleRotationChange(90)}><b>90&deg;</b> Landscape</Radio>
                        </div>
                        <div className="col-md-6">
                          <Radio name="ori" value="180" defaultChecked={this.state.rotation == 180 ? true: false} 
                          onClick={() => this.handleRotationChange(180)}><b>180&deg;</b> Portrait <i style={{color: '#aaa'}}>reversed</i></Radio>
                          <Radio name="ori" value="270" defaultChecked={this.state.rotation == 270 ? true: false} 
                          onClick={() => this.handleRotationChange(270)}><b>270&deg;</b> Landscape <i style={{color: '#aaa'}}>reversed</i></Radio>
                        </div>
                      </div>
                      <div className={device.displays.length != 1 ? 'visible row' : 'hidden'}>
                        <div className="alert alert-info">
                        <p><Fa name="info-circle"/>&nbsp;Display rotation settings are preconfigured for multi-display PicoSigns.</p>
                        </div>
                      </div>
                    </div>                  

                    <h5>Measurements</h5>
                    <hr/>
                    <div>
                        <div>
                            <Fa name='battery-3' style={{width:24}}/>
                            <div style={{display: 'inline-block', width:100 }}>Battery</div>
                            <Switch className="config-controls" size="mini" value={this.state.measure_battery_enabled}
                                    onChange= {() => this.handleSwitchToggle('measure_battery_enabled')} />
                            <div className={this.state.measure_battery_enabled ? 'inline': 'hidden'} >
                                <div className="input-group">
                                <span className="input-group-addon">every</span>
                                <input type="number" maxLength="4" name="measure_battery_period" className="form-control" value= {this.state.measure_battery_period} onChange={(e) => this.handleInputChange(e)} />
                                <span className="input-group-addon">sec.</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Fa name='wifi' style={{width:24}}/>
                            <div style={{display: 'inline-block', width:100 }}>Network</div>
                            <Switch className="config-controls" size="mini" value={this.state.measure_network_enabled}
                                    onChange= {() => this.handleSwitchToggle('measure_network_enabled')} />
                            <div className={this.state.measure_network_enabled ? 'inline': 'hidden'} >
                                <div className="input-group">
                                <span className="input-group-addon">every</span>
                                <input type="number" maxLength="4" name="measure_network_period" className="form-control" value= {this.state.measure_network_period} onChange={(e) => this.handleInputChange(e)} />
                                <span className="input-group-addon">sec.</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Fa name='thermometer-half' style={{width:24}}/>
                            <div style={{display: 'inline-block', width:100 }}>Temperature</div>
                            <Switch className="config-controls" size="mini" value={this.state.measure_temperature_enabled}
                                    onChange= {() => this.handleSwitchToggle('measure_temperature_enabled')} />
                            <div className={this.state.measure_temperature_enabled ? 'inline': 'hidden'} >
                                <div className="input-group">
                                <span className="input-group-addon">every</span>
                                <input type="number" maxLength="4" name="measure_temperature_period" className="form-control" value= {this.state.measure_temperature_period} onChange={(e) => this.handleInputChange(e)} />
                                <span className="input-group-addon">sec.</span>
                                </div>
                            </div>
                        </div>
                    </div> 
                  </div>

                  <div className="col-md-12">
                      <h5>Heartbeat</h5>
                      <hr/>
                      {device.comms_type !== 'POE' && <div>
                        <div>
                            <Fa name='heartbeat' style={{width:24}}/>
                            <div style={{display: 'inline-block', width:100 }}>Heartbeat</div>
                            <div className="inline">
                              <div className="input-group">
                                  <span className="input-group-addon">every</span>
                                  <input type="number" maxLength="4" name="heartbeat_default_value" className="form-control" value= {this.state.heartbeat_default_value} 
                                        onChange={(e) => this.handleInputChange(e)}/>
                                  <span className="input-group-addon">sec.</span>
                              </div>
                            </div>
                        </div>
                        <div style={{marginTop:20}}>
                            <Fa name='clock-o' style={{width:24}}/>
                            <div style={{display: 'inline-block', width:100 }}>Use schedules</div>
                            <div className="inline">  
                              <Switch className="config-controls" 
                               size="mini" value={this.state.use_schedules} onChange= {() => this.handleSwitchToggle('use_schedules')} />
                            </div>
                        </div>
                                                  
                        { this.state.schedules && this.state.schedules.length ?
                          this.state.schedules.map((item, i) =>
                          <ScheduleBox index={i} key={item.id} singleItem={item}
                              onFinishEdit={(s) => this.handleNewSchedule(s)} delete={(i) => this.handleScheduleDelete(i)}/>) :
                          <div>
                            <p style={{marginTop: 10}}>You don't have any schedules defined.</p>
                          </div>
                        }
                      
                        <div>
                          <p className='schedule-box new-schedule editing' onClick={() => this.handleScheduleAdd()}>
                            <Fa name='plus' />&nbsp;Add new schedule
                          </p>
                        </div>
                      
                      </div>}
                      
                      {device.comms_type === 'POE' && <div>
                        <p><Fa name='info-circle' />&nbsp;<i>This device is always available and does not need heartbeat.</i></p>
                            
                      </div>}
                </div> {/* end col*/}
              </div>
            </div>
          </div>
        </div>
      }
	    { !this.state.loading && this.state.error && errorDiv}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceSettings.js